'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { generateId } from '@/shared/lib/common';
import { ScrollArea, TextareaPrimitive } from '@ncai-axe/react-ui-v3';
import { useTranslations } from 'next-intl';
import { TagInput } from './TagInput';
import { TagFieldProps } from './types';
export default function TagField(t0) {
  const $ = _c(71);
  let className;
  let controlledInputValue;
  let maxTags;
  let onClickOutside;
  let onFocus;
  let onInputChange;
  let onKeyDown;
  let onTagAdd;
  let onTagRemove;
  let onTagsChange;
  let placeholder;
  let props;
  let style;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      tags: t1,
      onTagsChange,
      onInputChange,
      inputValue: controlledInputValue,
      placeholder,
      disabled: t2,
      state: t3,
      className,
      maxTags,
      style,
      onFocus,
      onTagRemove,
      onTagAdd,
      onKeyDown,
      onClickOutside,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = controlledInputValue;
    $[3] = maxTags;
    $[4] = onClickOutside;
    $[5] = onFocus;
    $[6] = onInputChange;
    $[7] = onKeyDown;
    $[8] = onTagAdd;
    $[9] = onTagRemove;
    $[10] = onTagsChange;
    $[11] = placeholder;
    $[12] = props;
    $[13] = style;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    className = $[1];
    controlledInputValue = $[2];
    maxTags = $[3];
    onClickOutside = $[4];
    onFocus = $[5];
    onInputChange = $[6];
    onKeyDown = $[7];
    onTagAdd = $[8];
    onTagRemove = $[9];
    onTagsChange = $[10];
    placeholder = $[11];
    props = $[12];
    style = $[13];
    t1 = $[14];
    t2 = $[15];
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[17] = t1;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const tags = t4;
  const disabled = t2 === undefined ? false : t2;
  const state = t3 === undefined ? undefined : t3;
  const t = useTranslations("common");
  let t5;
  if ($[19] !== placeholder || $[20] !== t) {
    t5 = placeholder ?? t("tagField.placeholder");
    $[19] = placeholder;
    $[20] = t;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const resolvedPlaceholder = t5;
  const tagFieldRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const effectiveInputValue = controlledInputValue ?? inputValue;
  let t6;
  if ($[22] !== onInputChange) {
    t6 = next => {
      setInputValue(next);
      onInputChange?.(next);
    };
    $[22] = onInputChange;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const emitInput = t6;
  let t7;
  if ($[24] !== emitInput || $[25] !== maxTags || $[26] !== onTagAdd || $[27] !== onTagsChange || $[28] !== tags) {
    t7 = tagValue => {
      if (maxTags && tags.length >= maxTags) {
        return;
      }
      if (!tagValue.trim() || tags.some(tag => tag.value === tagValue)) {
        return;
      }
      const id = generateId();
      const newTags = [...tags, {
        id,
        value: tagValue,
        label: tagValue
      }];
      onTagsChange?.(newTags);
      onTagAdd?.(tagValue);
      emitInput("");
    };
    $[24] = emitInput;
    $[25] = maxTags;
    $[26] = onTagAdd;
    $[27] = onTagsChange;
    $[28] = tags;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  const addTag = t7;
  let t8;
  if ($[30] !== onTagRemove || $[31] !== onTagsChange || $[32] !== tags) {
    t8 = id_0 => {
      const newTags_0 = tags.filter(tag_0 => tag_0.id !== id_0);
      onTagsChange?.(newTags_0);
      onTagRemove?.(id_0);
    };
    $[30] = onTagRemove;
    $[31] = onTagsChange;
    $[32] = tags;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  const removeTag = t8;
  let t9;
  if ($[34] !== addTag || $[35] !== disabled || $[36] !== effectiveInputValue || $[37] !== onKeyDown || $[38] !== removeTag || $[39] !== tags) {
    t9 = e => {
      if (disabled) {
        return;
      }
      if (e.nativeEvent.isComposing) {
        return;
      }
      onKeyDown?.(e);
      if (e.defaultPrevented) {
        return;
      }
      bb76: switch (e.key) {
        case "Enter":
          {
            e.preventDefault();
            addTag(effectiveInputValue.trim());
            break bb76;
          }
        case "Backspace":
          {
            if (!effectiveInputValue && tags.length > 0) {
              e.preventDefault();
              removeTag(tags[tags.length - 1].id);
            }
            break bb76;
          }
        case "Escape":
          {
            setInputValue("");
            break bb76;
          }
        case ",":
          {
            e.preventDefault();
            if (effectiveInputValue.trim()) {
              addTag(effectiveInputValue.trim());
            }
          }
      }
    };
    $[34] = addTag;
    $[35] = disabled;
    $[36] = effectiveInputValue;
    $[37] = onKeyDown;
    $[38] = removeTag;
    $[39] = tags;
    $[40] = t9;
  } else {
    t9 = $[40];
  }
  const handleKeyDown = t9;
  let t10;
  if ($[41] !== onFocus) {
    t10 = () => {
      onFocus?.();
    };
    $[41] = onFocus;
    $[42] = t10;
  } else {
    t10 = $[42];
  }
  const handleFocus = t10;
  let t11;
  if ($[43] !== onClickOutside) {
    t11 = () => {
      setTimeout(() => {
        onClickOutside?.();
      }, 150);
    };
    $[43] = onClickOutside;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  const handleClickOutside = t11;
  let t12;
  let t13;
  if ($[45] !== addTag || $[46] !== effectiveInputValue || $[47] !== handleClickOutside) {
    t12 = () => {
      const clickOutside = e_0 => {
        if (tagFieldRef.current && e_0.target instanceof Node && !tagFieldRef.current.contains(e_0.target)) {
          addTag(effectiveInputValue.trim());
          handleClickOutside();
        }
      };
      document.addEventListener("click", clickOutside);
      return () => {
        document.removeEventListener("click", clickOutside);
      };
    };
    t13 = [effectiveInputValue, addTag, handleClickOutside];
    $[45] = addTag;
    $[46] = effectiveInputValue;
    $[47] = handleClickOutside;
    $[48] = t12;
    $[49] = t13;
  } else {
    t12 = $[48];
    t13 = $[49];
  }
  useEffect(t12, t13);
  let t14;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      height: 60
    };
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== disabled || $[52] !== effectiveInputValue || $[53] !== emitInput || $[54] !== handleFocus || $[55] !== handleKeyDown || $[56] !== removeTag || $[57] !== resolvedPlaceholder || $[58] !== tags) {
    t15 = <ScrollArea style={t14}><TagInput tags={tags} inputValue={effectiveInputValue} placeholder={resolvedPlaceholder} disabled={disabled} onRemove={removeTag} onInputChange={emitInput} onKeyDown={handleKeyDown} onFocus={handleFocus} /></ScrollArea>;
    $[51] = disabled;
    $[52] = effectiveInputValue;
    $[53] = emitInput;
    $[54] = handleFocus;
    $[55] = handleKeyDown;
    $[56] = removeTag;
    $[57] = resolvedPlaceholder;
    $[58] = tags;
    $[59] = t15;
  } else {
    t15 = $[59];
  }
  let t16;
  if ($[60] !== state || $[61] !== t15) {
    t16 = <TextareaPrimitive.Container state={state} ref={tagFieldRef}>{t15}</TextareaPrimitive.Container>;
    $[60] = state;
    $[61] = t15;
    $[62] = t16;
  } else {
    t16 = $[62];
  }
  let t17;
  if ($[63] !== props.supportingLabel || $[64] !== state) {
    t17 = props.supportingLabel && <TextareaPrimitive.Support state={state} label={props.supportingLabel} />;
    $[63] = props.supportingLabel;
    $[64] = state;
    $[65] = t17;
  } else {
    t17 = $[65];
  }
  let t18;
  if ($[66] !== className || $[67] !== style || $[68] !== t16 || $[69] !== t17) {
    t18 = <div className={className} style={style}>{t16}{t17}</div>;
    $[66] = className;
    $[67] = style;
    $[68] = t16;
    $[69] = t17;
    $[70] = t18;
  } else {
    t18 = $[70];
  }
  return t18;
}